import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconQuestionMarkEmpty: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 18 18" width="18" height="18">
    <path d="M9 5.7c-.944 0-1.425.611-1.425 1.05v.45h-.9v-.45C6.675 5.689 7.694 4.8 9 4.8c1.306 0 2.325.889 2.325 1.95 0 .457-.116.843-.377 1.171-.248.312-.6.536-.997.734-.32.16-.402.28-.44.373-.054.136-.061.318-.061.722v.45h-.9v-.499c0-.332 0-.691.126-1.008.15-.374.443-.629.873-.843.36-.18.57-.332.695-.49.112-.14.18-.317.18-.61 0-.439-.48-1.05-1.424-1.05Zm0 6.75a.45.45 0 1 1 0-.9.45.45 0 0 1 0 .9Z" />
    <path
      fillRule="evenodd"
      d="M9 15.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Zm0-.9a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7Z"
      clipRule="evenodd"
    />
  </Icon>
);
